import ReactSelect from 'react-select'

const Select = ({ options, onChange = () => {}, ...props }) => {
    return (
        <ReactSelect
            options={options}
            styles={{
                indicatorSeparator: () => ({ display: "none" }),
                input: (styles) => ({
                    ...styles,
                    "> input": {
                        boxShadow: "none !important",
                    },
                }),
                control: (styles) => ({
                    ...styles,
                    height: '42px'
                })
            }}
            onChange={onChange}
            {...props}
        />
    )
}

export default Select